'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxRouter = require('redux-router');

var _audiences = require('./audiences');

var _audiences2 = _interopRequireDefault(_audiences);

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

var _eventDetail = require('./eventDetail');

var _eventDetail2 = _interopRequireDefault(_eventDetail);

var _featured = require('./featured');

var _featured2 = _interopRequireDefault(_featured);

var _organizations = require('./organizations');

var _organizations2 = _interopRequireDefault(_organizations);

var _regions = require('./regions');

var _regions2 = _interopRequireDefault(_regions);

var _tags = require('./tags');

var _tags2 = _interopRequireDefault(_tags);

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _venues = require('./venues');

var _venues2 = _interopRequireDefault(_venues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  router: _reduxRouter.routerStateReducer,
  audiences: _audiences2.default,
  events: _events2.default,
  eventDetail: _eventDetail2.default,
  featured: _featured2.default,
  organizations: _organizations2.default,
  regions: _regions2.default,
  tags: _tags2.default,
  types: _types2.default,
  search: _search2.default,
  venues: _venues2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1168
// module chunks = 0